module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('doc-section', {
    attrs: {
      "id": "navbar",
      "name": "Navbar"
    }
  }, [_c('div', {
    staticClass: "bs-example"
  }, [_c('navbar', {
    attrs: {
      "placement": _vm.placement,
      "type": _vm.type
    }
  }, [_c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "/",
      "title": "Home"
    },
    slot: "brand"
  }, [_vm._v("VueStrap")]), _vm._v(" "), _c('dropdown', {
    attrs: {
      "text": "Component List",
      "type": "primary"
    }
  }, _vm._l((_vm.sections), function(s) {
    return _c('li', [_c('a', {
      attrs: {
        "href": '#' + s.id
      },
      domProps: {
        "textContent": _vm._s(s.name)
      }
    })])
  })), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://github.com/themcaffee/vue-strap",
      "target": "_blank"
    }
  }, [_vm._v("\n          Fork this project on Github\n          "), _c('svg', {
    staticClass: "octicon octicon-mark-github",
    attrs: {
      "height": "16px",
      "fill": "#777",
      "viewBox": "0 0 16 16",
      "version": "1.1",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "d": "M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0 0 16 8c0-4.42-3.58-8-8-8z"
    }
  })])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Placement")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "clear-button": "",
      "options": ['top', 'bottom', 'static']
    },
    model: {
      value: (_vm.placement),
      callback: function($$v) {
        _vm.placement = $$v
      },
      expression: "placement"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Type")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "options": ['default', 'inverse']
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  })], 1)], 1), _vm._v(" "), _c('doc-code', {
    attrs: {
      "language": "markup"
    }
  }, [_vm._v("\n    <navbar placement=\"top\" type=\"default\">\n      <!-- Brand as slot -->\n      <a slot=\"brand\" href=\"/\" title=\"Home\" class=\"navbar-brand\">VueStrap</a>\n      <!-- You can use dropdown component -->\n      <dropdown text=\"Dropdown\">\n        <li><a href=\"link\">Option</a></li>\n      </dropdown>\n      <!-- Or normal bootstrap style -->\n      <li class=\"dropdown\">\n        <a href=\"#\" class=\"dropdown-toggle\">Dropdown</a>\n        <ul class=\"dropdown-menu\">\n          <li><a href=\"link\">Option</a></li>\n        </ul>\n      </li>\n      <!-- For positioning use slot=\"left\" or slot=\"right\" -->\n      <li slot=\"right\">\n        <a href=\"https://github.com/themcaffee/vue-strap\" target=\"_blank\">Fork...</a>\n      </li>\n    </navbar>\n  ")]), _vm._v(" "), _c('doc-table', [_c('div', [_c('p', [_vm._v("placement")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("String")]), _vm._v(", one of "), _c('code', [_vm._v("top")]), _vm._v(", "), _c('code', [_vm._v("bottom")]), _vm._v(", "), _c('code', [_vm._v("static")]), _vm._v(", or empty for normal.")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("''")])]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', [_c('p', [_vm._v("type")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("String")]), _vm._v(", one of "), _c('code', [_vm._v("inverse")]), _vm._v(", "), _c('code', [_vm._v("default")]), _vm._v(".")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("default")])]), _vm._v(" "), _c('p')])])], 1)
},staticRenderFns: []}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-11222b20", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-11222b20!./~/vue-loader/lib/selector.js?type=template&index=0!./docs/example/navbarDocs.vue
// module id = 233
// module chunks = 0